<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor">&nbsp;Invoicing /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Pending</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="container">
            <BulkCreationLogBanner
              class="mt-3"
              v-if="viewBulkInvoice"
              :logs="bulkCreationLog"
              @dismiss="dismissBulkLog"
            />
            <PendingInvoiceOverviewCard/>
            
            <div class="row">
              <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="search-table container-fluid">
                  <!-- <div class="row"> -->
                    <!-- <div class="col-lg-12 col-sm mobile-div"> -->
                      <div class="row">
                        <div class="col-lg-4 col-sm mobile-div">
                          Invoice No.
                          <input type="text" class="form-control" name="search_invoice_id" v-model="searchInvoiceNo" placeholder="Invoice Number">
                        </div>
                        <div class="col-lg-4 col-sm mobile-div">
                          Company Name
                          <multiselect v-model="searchCompany" :options="dataCompany" label="companyName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="companyName" :multiple="false" :close-on-select="true"></multiselect>
                        </div>
                        <div class="col-lg-4 col-sm mobile-div" style="padding-right : 0px;">
                          Order ID
                          <input type="text" class="form-control w-100" v-model="searchOrderId" placeholder="Order ID">
                        </div>
                        <div class="col-lg-4 col-sm mobile-div">
                          Billing Cycle Start
                          <input type="date" class="form-control" name="search_invoice_billing_start_date" v-model="searchBillingCycleStart">
                        </div>
                        <div class="col-lg-4 col-sm mobile-div">
                          Billing Cycle End
                          <input type="date" class="form-control" name="search_invoice_billing_end_date" v-model="searchBillingCycleEnd">
                        </div>
                        <div class="col-lg-3 col-sm mobile-div" >
                            Progress Status
                            <multiselect v-model="searchProgressStatus" :options="progressStatusOptions" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="false" :close-on-select="true"></multiselect>
                        </div>
                        <div class="col-lg-1 col-sm mobile-div" style="padding-left : 0px;">
                          <button class="btn btn-primary mt-4" @click="searchData"> Search </button>
                        </div>
                       
                      </div>
                    <!-- </div> -->
                    
                  <!-- </div> -->
                 
                </div>

                <!-- Action Button -->
                <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                  <div class="d-flex align-items-center">
                    <button class="btn btn-secondary btn-md mb-2 mt-3" :disabled="loadingCreateInvoiceProcess == true" v-if="selectedRows.length == 0"> 
                      <i class="fas fa-solid fa-paper-plane"></i>
                      Create Invoice 
                    </button>
                    <button class="btn btn-primary btn-md mb-2 mt-3" :disabled="loadingCreateInvoiceProcess == true" @click="createInvoice" v-else> 
                      <i class="fas fa-solid fa-paper-plane"></i>
                      Create Invoice 
                      <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 1px;" v-if="loadingCreateInvoiceProcess == true"/>
                    </button>
                    <button class="btn btn-secondary btn-md mb-2 mt-3 ml-3" @click="mergeInvoice" v-if="selectedRows.length < 2"> 
                      <i class="fas fa-solid fa-share-alt"></i>
                      Merge
                    </button>
                    <button class="btn btn-primary btn-md mb-2 mt-3 ml-3" @click="mergeInvoice" v-else> 
                      <i class="fas fa-solid fa-share-alt"></i>
                      Merge
                      <img src="~@/assets/images/2.gif" style="height: 24px;" v-if="loadingMergeInvoice == true">
                    </button>
                    <button class="btn btn-secondary btn-md mb-2 mt-3 ml-3" :disabled="loadingIgnoreInvoiceProcess == true" v-if="selectedRows.length == 0 && viewInvoiceIgnored"> 
                      <img src="~@/assets/icon/ignore-doc.png" style="height: 22px;">
                      Ignore Invoice 
                    </button>
                    <button class="btn btn-primary btn-md mb-2 mt-3 ml-3" :disabled="loadingIgnoreInvoiceProcess == true" @click="showIgnoreInvoiceModal" v-else-if="selectedRows.length > 0 && viewInvoiceIgnored"> 
                      <img src="~@/assets/icon/ignore-doc.png" style="height: 22px;">
                      Ignore Invoice 
                      <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 1px;" v-if="loadingIgnoreInvoiceProcess == true"/>
                    </button>
                  </div>
                  <div>
                    <button
                      v-if="createBulkInvoice"
                      class="btn btn-outline-primary btn-md"
                      @click="showModalGenerateBulkInvoice"
                    >
                      <i class="fas fa-file-invoice"></i>
                      Bulk Generate Invoices
                      <img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 1px;" v-if="loadingBulkGenerateInvoice == true"/>
                    </button>
                  </div>
                </div>
                

                <span 
                  class="ml-3" 
                  style="
                    color: #FF5D5D;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                    letter-spacing: -0.016px;"
                >
                    {{errorModifyInvoiceData}} 
                </span>
        
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th style=" text-align: center;"> 
                        <input type="checkbox" @change="selectAllRows" :checked="checkIsSelectAll()">
                      </th>
                      <th style=" text-align: center;">Invoice No.</th>  
                      <th style=" text-align: center;">Company Name</th>
                      <th style=" text-align: center;">Total Amount</th>
                      <!-- <th style=" text-align: center;">Invoice Category</th> -->
                      <th style=" text-align: center;">Billing Cycle</th>
                      <th style=" text-align: center;">Billed Per</th>
                      <th style=" text-align: center;">Due Date</th>
                      <th style=" text-align: center;">Document Status</th>
                    </tr>
                  </thead>
                    <tbody>
                      <tr v-if="loadingTable === false && totalData == 0">
                        <td colspan="9" class="text-center">Data Not Available</td>
                      </tr>
                      <tr v-else-if="loadingTable === true">
                        <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                      </tr>
                      <tr v-for="(data,index) in pendingInvoiceData" :key="index" v-else-if="loadingTable === false && totalData != 0">
                        <td style=" text-align: center;">
                          <input type="checkbox" v-model="selectedRows" :value="data" v-if="!['Pending','On Progress'].includes(data.jurnalStatus)">
                        </td>
                        <td>
                          {{data.code}}
                        </td>
                        <td>
                          <router-link 
                            :to="{
                              path:'/invoicing/pending/detail', 
                              query: {
                                companyName : data.companyName,
                                invoiceId : data.invoiceId,
                                page : 1,
                                itemPerPage : 10,
                              }
                            }"
                          >
                          {{ data.companyName }}
                          </router-link>
                          <div> 
                            <div class="badge jurnal-badge-warning" v-if="data.jurnalStatus == 'Pending' || data.jurnalStatus == 'On Progress'">
                              <img src="@/assets/icon/icon-danger.png" style="width: 14px; margin-bottom : 2px;margin-top : 1px;"/>
                              <span style="margin-top : 2px;">{{data.jurnalStatus}}</span>
                            </div>
                            <div class="badge jurnal-badge-danger" v-if="data.jurnalStatus == 'Failed'">
                              <img src="@/assets/icon/icon-failed.png" style="width: 14px; margin-bottom : 2px;margin-top : 1px;"/>
                              <span style="margin-top : 2px;">{{data.jurnalStatus}}</span>
                            </div>
                          </div>
                        </td>
                        <td width="15%" style=" text-align: center;">Rp {{formatPrice(data.totalAmount)}}</td>
                        <!-- <td>Invoice Category</td> -->
                        <td>
                          <div class="row">
                            <div class="col-12" style=" text-align: center;">
                              <div>
                                {{formatDate(data.billingCycle, 'DD MMMM YYYY')}}
                                <span>
                                  <button class="btn btn-link" @click="showUpdateBillingDateModal(data.billingCycle, data.invoiceId)">
                                  <svg xmlns="http://www.w3.org/2000/svg" height="0.9em" viewBox="0 0 512 512" style="fill : #3099f8; margin-bottom : 6px">
                                    <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"/>
                                  </svg>
                                  <!-- <i class="fa fa-pencil" aria-hidden="true" @click="showUpdateBillingDateModal" v-if="new Date(data.billingDate) < new Date()"></i> -->
                                  </button>
                                </span>
                              </div>
                              <span v-if="new Date(data.billingCycle).setHours(23, 59,59) < new Date()"
                              style="color: #FF5D5D;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 20px;
                                letter-spacing: -0.016px;">
                                (Overdue)
                              </span>
                              
                            </div>
                          </div>
                        </td>
                        <td style=" text-align: center;">{{ data.billedPer}}</td>
                        <td style=" text-align: center;">{{ formatDate(data.dueDate, 'DD MMM YYYY') }}</td>
                        <td width='10%' style=" text-align: center;">{{ data.documentStatus}}</td>
                      </tr>
                    </tbody>
                </table>
                <div id="wrapperr">
                    <div id="c1" style="display: inline-flex;">
                      <div style="margin-right: 10px;">
                        <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage()">
                                <option value="10">10</option>
                                <option value="40">40</option>
                                <option value="80">80</option>
                        </select>
                      </div>
                      <div class="alignLeft total-data">
                        Total Data {{ totalData }} 
                      </div>
                    </div>
                    <div id="c2">
                      <div class="pagination p8 alignRight">
                        <ul>
                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                          <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                          <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>{{'>'}}</li></a>
                        </ul>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalUpdateInvoiceBillingDate :isExclude="false" :billingCycle="newBillingCycle" :setNewBillingCycle="setNewBillingCycle" :executeChanges="modifyBillingCycle"/>
    <ModalIgnoreInvoice :invoiceIds="selectedRows"></ModalIgnoreInvoice>
    <ModalBulkGenerateInvoice :companyOptions="dataCompany"  @onSuccess="getData" @onUnauthorized="handleLogout"/>
  </div>
</template>

<script>
import { required} from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
import PendingInvoiceOverviewCard from './CustomComponent/PendingInvoiceOverviewCard.vue'
import ModalUpdateInvoiceBillingDate from './CustomComponent/ModalUpdateInvoiceBillingDate.vue'
import ModalIgnoreInvoice from './CustomComponent/ModalIgnoreInvoice.vue'
import ModalBulkGenerateInvoice from './CustomComponent/ModalBulkGenerateInvoice.vue'
import BulkCreationLogBanner from './CustomComponent/BulkCreationLogBanner.vue'
import moment from "moment";

export default {
  name: 'PendingInvoicePage',
  components:{
    SideBar,
    Multiselect,
    PendingInvoiceOverviewCard,
    ModalUpdateInvoiceBillingDate,
    ModalIgnoreInvoice,
    ModalBulkGenerateInvoice,
    BulkCreationLogBanner,
    // VueDatePicker
  },
  data () {
    return {
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      viewInvoicing : false,
      viewPendingInvoice : false,
      viewInvoiceIgnored : false,
      viewBulkInvoice: false,
      createBulkInvoice : false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      dataComplain: [],
      orderId:"",
      companyName:"",
      statusOrder:"",
      loadingTable: true,
      loadingButtonProcess:false,
      loadingCreateInvoiceProcess:false,
      loadingIgnoreInvoiceProcess:false,
      codeChoose:'',
      productCode:[],
      companyChoose:'',
      lesseeCompany:[],
      problem:'',
      picName:'',
      picPhone:'',
      note:'',
      countOrderCode:0,
      caseKnowledge:[],
      caseKnowledgeShow:false,
      idBefore:[],
      isSolution:false,
      endOfCase:false,
      caseInfo:'',
      fieldCompanyError:false,
      fieldCodeError:false,
      fieldTypeSameError:false,
      fieldProblemError:false,
      fieldClientAddressError:false,
      errorMessage:'',
      monthName : ['January','February','March','April','May','June','July','August','September','October','November','December'],
      pendingInvoiceData : [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      itemPerPage : 10,
      selectedRows : [], 
      isCheckAll : false,
      dataCompany : [],
      searchCompany : '',
      searchBillingCycleStart : null,
      searchBillingCycleEnd : null,
      searchOrderId : '',
      errorModifyInvoiceData : '',
      searchInvoiceNo : '',
      progressStatusOptions : [
        {
          status : '',
          statusName: 'All',
        },
        {
          status : 'Pending',
          statusName: 'Pending',
        },
        {
          status : 'On Progress',
          statusName: 'On Progress',
        },
        {
          status : 'Failed',
          statusName: 'Failed',
        },
      ],
      searchProgressStatus : {
        status : '',
        statusName: 'All'
      },
      searchInvoiceCategory : '',
      newBillingCycle : '',
      selectedInvoiceId : '',
      loadingMergeInvoice : false,
      loadingBulkGenerateInvoice : false,
      bulkCreationLog: [],
    }
  },
  validations: {
        picName: {
            required
        },
        picPhone: {
            required,
            phoneFormat(phoneNumber) {
                return (
                    phoneNumber.toString().substring(0, 3) == '628' ||
                    phoneNumber.toString().substring(0, 2) == '08' ||
                    phoneNumber.toString().substring(0, 2) == '02'
                )
            },
        },
        validationNext: ['picName', 'picPhone'],
    },
  methods: {
    showModalGenerateBulkInvoice() {
      $(`#modalBulkGenerateInvoice`).modal("show");
    },
    setNewBillingCycle(newdata) {
      // for update all billing cycle
      this.newBillingCycle = newdata
    },
    modifyBillingCycle(isChangeAllBillingDate) {
      var self = this
        // For modify All
        this.$http.post(`${process.env.UPDATE_INVOICE_BILLING_CYCLE}`,
        {
          invoiceId: this.selectedInvoiceId,
          billingCycle: this.newBillingCycle,
          allUpdate : isChangeAllBillingDate,
          isPending:true,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status != 200) {
            swal('Error', response.data.message, 'error').then(() => {
              this.newBillingCycle = this.invoiceBillingCycle
            })
          } else {
            swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
              window.location.reload();
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              this.newBillingCycle = this.invoiceBillingCycle
            }
          })
        })
      
    },
    formatDate(value, dateFormat) {
      return moment(value).format(dateFormat)
    },
    createInvoice() {
      if(this.selectedRows.length > 0) {
        this.loadingCreateInvoiceProcess = true
        this.errorModifyInvoiceData = ''
        let invoiceIdToCreateArr = this.selectedRows.map(item => {return Number(item.invoiceId)})

        var self = this
        this.$http.post(process.env.CREATE_INVOICE,{
          invoiceIds : invoiceIdToCreateArr
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status !== 200) {
            this.errorModifyInvoiceData = response.data.message
            this.selectedRows = []
            localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
            this.loadingCreateInvoiceProcess = false
          } else {
            swal('Success', response.data.message, 'success').then(() => { 
              this.selectedRows = []
              localStorage.setItem("selectedPendingInvoice", JSON.stringify(this.selectedRows))
              this.loadingCreateInvoiceProcess= false
              this.getData()            
            })
          }
        })
        .catch(error => {
            self.errorModifyInvoiceData = error.message
            self.selectedRows = []
            localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
            self.loadingCreateInvoiceProcess= false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
        })
      } else {
        this.errorModifyInvoiceData = 'Mohon pilih data terlebih dahulu'
        this.loadingCreateInvoiceProcess= false
      }
    },
    mergeInvoice() {
      if(this.selectedRows.length == 0) {
        this.errorModifyInvoiceData = 'Mohon pilih data terlebih dahulu'
      } else if(this.selectedRows.length == 1) {
        this.errorModifyInvoiceData = 'Mohon pilih data terlebih dahulu, membutuhkan minimal 2 data untuk merge'
      } else {
        this.loadingMergeInvoice = true
        this.errorModifyInvoiceData = ''
        const mergedInvoice = this.selectedRows.map(item => {return Number(item.invoiceId)})
        this.$http.post(process.env.MERGE_INVOICE,{
          mergeInvoiceIds: mergedInvoice,
        },{
          timeout: 300 * 1000,
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status !== 200) {
            this.loadingMergeInvoice = false
            this.errorModifyInvoiceData = response.data.message
            this.selectedRows = []
            localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
          } else {
            swal('Success', response.data.message, 'success').then(() => {
              this.loadingMergeInvoice = false
              this.selectedRows = []
              localStorage.setItem("selectedPendingInvoice", JSON.stringify(this.selectedRows))
              this.getData()
            })
          }
        })
        .catch(error => {
          this.loadingMergeInvoice = false
          this.errorModifyInvoiceData = error.message
          this.selectedRows = []
          localStorage.setItem("selectedPendingInvoice", JSON.stringify([]))
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      }
    },
    // formatPrice(value) {
    //   let val = value  ? value : 0;
    //   return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // },
    formatPrice(value) {
        let val = value  ? Number(value) : Number(0)
        const round = val.toString().split('.')[0]
        const decimal = val.toString().split('.')[1]

        let result = round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        result = decimal ? `${result},${decimal}` : `${result},00`
      
        return result
    },
    showUpdateBillingDateModal (date, id) {
      this.setNewBillingCycle(date)
      this.selectedInvoiceId = id
      $(`#modalUpdateInvoiceBillingDate`).modal("show");
    },
    showIgnoreInvoiceModal () {
      $(`#modalIgnoreInvoice`).modal("show");
    },
    showPage () {
      this.$router.push({path:'/invoicing/pending', query: {
          page : 1,
          itemPerPage : this.itemPerPage,
          companyId: this.searchCompany ? this.searchCompany.companyId : '',
          companyName: this.searchCompany ? this.searchCompany.companyName : '',
          billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
          billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
          invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
          jurnalStatus : this.searchProgressStatus ? this.searchProgressStatus.status : '',
          jurnalStatusName : this.searchProgressStatus ? this.searchProgressStatus.statusName : '',
          orderId : this.searchOrderId ? this.searchOrderId : '',
        }
      })
    },
    checkIsSelectAll() {
      let checked = 0
      this.pendingInvoiceData.forEach(data => {
        if(this.selectedRows.find(item => item.invoiceId == data.invoiceId)) {
          checked += 1
        }
      })

      if( this.pendingInvoiceData.length > 0&& checked == this.pendingInvoiceData.length) {
        return true
      } else {
        return false
      }
    },
    selectAllRows() {
      const isSelectAll = this.checkIsSelectAll()
      console.log(isSelectAll)
      let datas = this.pendingInvoiceData
      if (!isSelectAll) {
        datas.forEach(item => {
          if(!this.selectedRows.find(data => data.invoiceId == item.invoiceId)) {
            this.selectedRows.push(item)
          }
        })
        localStorage.setItem("selectedPendingInvoice", JSON.stringify(this.selectedRows))
      } else {
       datas.forEach(item => {
          const index = this.selectedRows.findIndex(data => item.invoiceId == data.invoiceId); 
          if(this.selectedRows.find(data => item.invoiceId == data.invoiceId)) {
            this.selectedRows.splice(index, 1);
          }
        })
        localStorage.setItem("selectedPendingInvoice", JSON.stringify(this.selectedRows))
      }
    },
    getCompanyData() {
      this.$http.get(process.env.GET_COMPANY, {
        headers: { "Asani-Token": localStorage.getItem("jwt") },
      })
      .then((response) => {
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          this.handleLogout();
        } else {
          this.dataCompany = [{companyId : null, companyName : 'All'}, ...response.data.content];
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      });          
    },
    closeModal(name){
      $("#modal"+name).modal('hide')
    },
    isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
    },
    cekField: function(buttonName){
      var error = 0
      this.fieldCompanyError = false
      this.fieldCodeError = false
      this.fieldTypeSameError = false
      this.fieldPicNameError = false
      this.fieldPicPhoneError = false
      this.$v.validationNext.$touch()

      if (buttonName == 'etc' && this.problem == '') {
          error = error+1
          this.fieldProblemError = true
      } else if(buttonName == 'etc' && this.clientAddress == '') {
        error = error+1
        this.fieldClientAddressError= true
      } else{
          if (this.companyChoose == '') {
            error = error+1
            this.fieldCompanyError = true
          }
          if (this.codeChoose == '') {
            error = error+1
            this.fieldCodeError = true
          }
          if (this.countOrderCode == '2' && this.typeChoose == '') {
            error = error+1
            this.fieldTypeSameError = true
          }
          if (this.$v.validationNext.$invalid) {
             error = error+1           
          }
      }
      return error
    },

    openModal(x) {
      $("#modal"+x).modal('show')
    },
    searchData(){     
      this.$router.push({path:'/invoicing/pending', query: {
          page : 1,
          itemPerPage : 10,
          companyId: this.searchCompany ? this.searchCompany.companyId : '',
          companyName: this.searchCompany ? 
            (!this.searchCompany.companyName || this.searchCompany.companyName == 'ALL' ? '' : this.searchCompany.companyName) : '',
          billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
          billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
          invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
          jurnalStatus : this.searchProgressStatus.status ? this.searchProgressStatus.status : '',
          jurnalStatusName : this.searchProgressStatus ? 
            (!this.searchProgressStatus.statusName || this.searchProgressStatus.statusName == 'ALL' ? '' : this.searchProgressStatus.statusName) : '',
          orderId : this.searchOrderId ? this.searchOrderId : '',
        }
      })
      // this.getData()
    },
    toDataPage(pagePost){
      this.loadingTable = true
      this.$router.push({path:'/invoicing/pending', query: {
          page : pagePost,
          itemPerPage : this.itemPerPage,
          companyId: this.searchCompany ? this.searchCompany.companyId : '',
          companyName: this.searchCompany ? this.searchCompany.companyName : '',
          billingCycleStart : this.searchBillingCycleStart ?  this.searchBillingCycleStart  : '',
          billingCycleEnd : this.searchBillingCycleEnd ?  this.searchBillingCycleEnd  : '',
          invoiceNumber: this.searchInvoiceNo ? this.searchInvoiceNo : '',
          jurnalStatus : this.searchProgressStatus ? this.searchProgressStatus.status : '',
          jurnalStatusName : this.searchProgressStatus ? this.searchProgressStatus.statusName : '',
          orderId : this.searchOrderId ? this.searchOrderId : '',
        }
      })
     
      this.getData()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }

        if(this.permission[i] == '21') {
          this.viewInvoicing = true
        }
         if(this.permission[i] == '21.1') {
          this.viewPendingInvoice = true
        }
        if(this.permission[i] == '21.5') {
          this.viewInvoiceIgnored = true
        }
        if(this.permission[i] == '21.6') {
          this.viewBulkInvoice = true
        }
        if(this.permission[i] == '21.7') {
          this.createBulkInvoice = true
        }
      }
      if (this.viewPendingInvoice == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    getData(){
      this.getBulkLog()
      if( this.$route.query.companyId && this.$route.query.companyName) {
        this.searchCompany = {
          companyId : this.$route.query.companyId,
          companyName: this.$route.query.companyName
        }
      }

      if( this.$route.query.jurnalStatus && this.$route.query.jurnalStatusName) {
        this.searchProgressStatus = {
          status : this.$route.query.jurnalStatus,
          statusName: this.$route.query.jurnalStatusName
        }
      }

      this.searchBillingCycleStart = this.$route.query.billingCycleStart
      this.searchBillingCycleEnd = this.$route.query.billingCycleEnd
      this.searchInvoiceNo = this.$route.query.invoiceNumber
      this.searchOrderId = this.$route.query.orderId

      this.currentPage = parseInt(this.$route.query.page)
      this.itemPerPage = parseInt(this.$route.query.itemPerPage)

      this.loadingTable = true
      this.$http.post(`${process.env.GET_INVOICE_LIST}?pending_invoice=true`,{
        page: Number(this.$route.query.page),
        itemPerPage : Number(this.$route.query.itemPerPage),
        companyId: this.searchCompany.companyId ? Number(this.searchCompany.companyId) : null,
        companyName : this.searchCompany.companyName ? this.searchCompany.companyName : null ,
        billingCycleStart : this.$route.query.billingCycleStart ?  this.$route.query.billingCycleStart  : '',
        billingCycleEnd : this.$route.query.billingCycleEnd ?  this.$route.query.billingCycleEnd  : '',
        invoiceCode : this.$route.query.invoiceNumber ? this.$route.query.invoiceNumber  : '',
        jurnalStatus : this.$route.query.jurnalStatus ? this.$route.query.jurnalStatus : '',
        invoiceStatus: '',
        orderId : this.$route.query.orderId ? this.$route.query.orderId : '',
      },{
        timeout: 20 * 6000,
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if(response.data.status !== 200) {
          this.pendingInvoiceData = []
          swal("Error", response.data.message , "error")
          this.loadingTable = false
        } else {

          this.pendingInvoiceData = response.data.data.data ? [...response.data.data.data] : [...this.pendingInvoiceData] 
          this.totalPage = response.data.data.totalPage
          this.totalData = response.data.data.totalData
          this.currentPage = response.data.data.currentPage
          this.loadingTable = false
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getBulkLog() {
      if(this.viewBulkInvoice) {

        this.$http.get(process.env.GET_LOG_BULK_PROGRESS, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status == 200) {
            this.bulkCreationLog = response.data.data
          } else {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          }
          
        })
        .catch(error => {
          if(error.response.data.status != 401) {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            })
            return
          }
        })
      }
    },
    startBulkLogPolling() {
      // Jalankan langsung pertama kali
      // this.getBulkLog()

      // Lalu jalankan setiap 20 menit (20 * 60 * 1000 ms)
      this.bulkLogPollingInterval = setInterval(() => {
        this.getBulkLog()
      }, 5 * 60 * 1000)
    },

    stopBulkLogPolling() {
      if (this.bulkLogPollingInterval) {
        clearInterval(this.bulkLogPollingInterval)
        this.bulkLogPollingInterval = null
      }
    },
    dismissBulkLog(index) {
      
      const deletedLogData = [...this.bulkCreationLog[index].notificationIds]
      this.$http.post(process.env.CLOSE_LOG_BULK_PROGRESS,{
        notificationIds : deletedLogData
      },{
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        if(response.data.status == 200) {
          this.bulkCreationLog.splice(index, 1)
        } else {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
        }
      })
      .catch(error => {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      })
    },
    sendLog(x){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'
        var productName = this.productNameChoose
        this.$http.post(process.env.LOG_URL+"/ticket/"+x,{
            codeLogs: 36,
            params: [],
        },{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
        })
        .catch(error => {
            console.log(error)
        })
    }
  },  
  created(){
    this.selectedRows = localStorage.getItem("selectedPendingInvoice") ? JSON.parse(localStorage.getItem("selectedPendingInvoice")) : [];
    localStorage.setItem("selectedIgnoreInvoice", JSON.stringify([]))
    this.admin = localStorage.getItem('admin_name')
    this.cekLogin()
    this.cekPermission()
    this.getData()
    this.getCompanyData()
    this.startBulkLogPolling()
    // this.getBulkLog()
  },
  beforeDestroy() {
    this.stopBulkLogPolling()
  },
  watch: {
    selectedRows: function (a) {
      localStorage.setItem("selectedPendingInvoice", JSON.stringify(a));
    },
  }
}
$(document).ready(function(){
  var self = this
$('#modalCreate').on('hidden.bs.modal', function () {
    // self.wadaw()
});
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .jurnal-badge-warning{
    border-radius: 50rem;
    background: #FFDEA5;
    color: #F06400;
    padding-left: 8px;
    padding-right: 8px;
  }
  .jurnal-badge-danger{
    border-radius: 50rem;
    background: #FFC5CA;
    color: #EE2737;
    padding-left: 8px;
    padding-right: 8px;
  }

  .title-square-background {
    background-color: #F8F9FB;
  }

  .invoice-overview-indicator{
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .invoice-overview-value {
    color: #000;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    letter-spacing: -0.02px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .case-knowledge:hover{
    cursor: pointer;
    background-color: #2797FB;
    color: white;
  }
.key{
  width: 168px;
  margin: 7px 0px;
}
.titik2{
  margin: 7px 0px;
  padding: 0px 9px;
}
.field{
  width: 100%;
}
.one-line{
  display: flex;
  margin: 4px 0px;
}
.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/InvoicePendingPage.vue